export enum DocumentType {
  Word = 'WORD',
  Excel = 'EXCEL',
  Pdf = 'PDF',
}
